import { DeliveryInfoList } from "./delivery-info-list";
import { PerformanceDateList } from "./performance-date-list";
import * as Styled from "./style";
import type { DeliveryProps } from "./type";
import { useDeliverySearch } from "./use-delivery-search";

export const Delivery = (props: DeliveryProps) => {
  const { videoStageSeasonData } = props;

  const { performanceProcessData, filterPerformanceProcessData } = useDeliverySearch({ videoStageSeasonData });

  return (
    <Styled.DivDeliveryWrapper>
      <PerformanceDateList
        allPerformances={videoStageSeasonData.allPerformances}
        filterPerformanceProcessData={filterPerformanceProcessData}
      />

      <DeliveryInfoList performanceProcessData={performanceProcessData} />
    </Styled.DivDeliveryWrapper>
  );
};
